import { isEmpty } from 'lodash';
import Analytics, { OptimisationInputEvent } from '@ecs-uk/web-common-analytics';
import { flowletDecisions } from '../../../constants';

export const triggerECD2EventsOnload = ({ testName, testVariant, testArea = 'Product Movement' }) => {
  Analytics.publishOnce(
    OptimisationInputEvent.fromObject({
      testName,
      testVariant,
      testArea,
    }),
    testName
  );
};

export const handleControlVariant = ({ targetedFeaturesFlowletId, conductricsDecisions, defaultTestName }) => {
  if (!defaultTestName) return;

  const flowletDecision = flowletDecisions.find(value => value?.flowletId === targetedFeaturesFlowletId);
  if (!flowletDecision) return;

  const { testAgentWithControlECD } = flowletDecision;
  const cachedTestData = isEmpty(testAgentWithControlECD)
    ? {}
    : testAgentWithControlECD.reduce((acc, testData) => {
        acc[testData?.agent] = testData;
        return acc;
      }, {});

  const decision = conductricsDecisions.find(agent => cachedTestData[agent?.id]);
  if (!decision) return;

  const selectedAgent = cachedTestData[decision.id] || {};

  if (['A'].includes(decision.variant)) {
    triggerECD2EventsOnload({
      testName: selectedAgent?.ecdTestName || defaultTestName,
      testVariant: decision.variant,
    });
  }
};

export const handleAgentControlVariant = ({ conductricsDecisions, agentCode, defaultTestName }) => {
  const decision = conductricsDecisions.find(d => d.id === agentCode);
  if (decision?.variant === 'A') {
    triggerECD2EventsOnload({ testName: defaultTestName, testVariant: 'A' });
  }
};
